import React from 'react'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import Box from '@mui/material/Box'

import { ServiceDraggableCard } from './ServiceDraggableCard'
import { useDragData } from '@user/utils/Draggable/hooks'
import { DraggableItemWrapper, DropResult } from '@user/utils/Draggable'

type Props = {
  onDragEnd: (result: DropResult) => void
  services: ILeadOppProduct[]
}

export function DragServicesList({ onDragEnd, services }: Props) {
  const { containerRef, itemRefs, draggingIndex, offsets } = useDragData({
    dataList: services,
    onDragEnd,
  })

  return (
    <Box ref={containerRef} id="services">
      {services.map((service, i) => (
        <DraggableItemWrapper
          key={service.id}
          ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
          draggingIndex={draggingIndex}
          index={i}
          offsets={offsets}
        >
          <ServiceDraggableCard leadOppProduct={service} />
        </DraggableItemWrapper>
      ))}
    </Box>
  )
}
